import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { RequestTableRowComponent } from '../../components/dashboard/request-table/request-table-row/request-table-row.component';
import { RequestTableComponent } from '../../components/dashboard/request-table/request-table.component';
import { DashboardPage } from '../../components/dashboard/dashboard.page';
import { DashboardFilterComponent } from '../../components/dashboard/dashboardfilter/dashboardfilter.component';
import { NoRequestsComponent } from '../../components/dashboard/no-requests/no-requests.component';
import { DashboardHeaderComponent } from '../../components/dashboard/dashboard-header/dashboard-header.component';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { OpenIdConfigService } from '../../services/openidconfig.service';
import { isObservable, Observable } from 'rxjs';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularDraggableModule } from 'angular2-draggable';
import { QRCodeModule } from 'angularx-qrcode';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { AppComponent } from '../../components/app/app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DialogChangeWorkgroupComponent } from '../../components/dashboard/dialogchangeworkgroup/dialogchangeworkgroup.component';
import { NewRequestPickerComponent } from 'src/app/components/dashboard/new-request-picker/new-request-picker.component';
import { RequestTableIsLoadingRowComponent } from 'src/app/components/dashboard/request-table/request-table-row/request-table-is-loading-row.component';
import { DashboardActionDropdownComponent } from 'src/app/components/dashboard/dashboard-action-dropdown/dashboard-action-dropdown.component';


const authFactory = (openIdConfigService: OpenIdConfigService) => {
  const config = openIdConfigService.getConfig();
  if (isObservable(config)) {
    return new StsConfigHttpLoader(<Observable<OpenIdConfiguration>>config);
  } else {
    return new StsConfigStaticLoader(<OpenIdConfiguration>config);
  }
};

@NgModule({
  declarations: [
    // Page
    DashboardPage,
    // Components
    DashboardActionDropdownComponent,
    DashboardFilterComponent,
    RequestTableComponent,
    RequestTableRowComponent,
    NoRequestsComponent,
    DashboardHeaderComponent,
    NewRequestPickerComponent,
    DialogChangeWorkgroupComponent,
    RequestTableIsLoadingRowComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AngularDraggableModule,
    DragDropModule,
    InfiniteScrollModule,
    NgxPanZoomModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OpenIdConfigService],
      }
    }),
    AngularSignaturePadModule,
    QRCodeModule
  ],

  bootstrap: [AppComponent]
})
export class DashboardModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}